import { ModalOptions } from 'ngx-bootstrap/modal';

export const ModalConfig: ModalOptions<any> = {
	ignoreBackdropClick: true,
	ariaLabelledBy: 'modal-cnt__tl'
};
